import type { MCWithParams } from 'components/uiKit/Modal'
import Modal from 'components/uiKit/Modal'

import type { ICodeEditorProps } from '../CodeEditor/CodeEditor'
import CodeEditor from '../CodeEditor/CodeEditor'
import * as s from './CodeEditorModal.module.scss'

const CodeEditorModal: MCWithParams<Omit<ICodeEditorProps, 'onRun'>> = ({ params, onClose }) => {
  return (
    <Modal minHeight='100%' name='CodeEditorModal' styleType='fullScreen'>
      <div className={s.root}>
        <CodeEditor {...params} onRun={onClose} />
      </div>
    </Modal>
  )
}

export default CodeEditorModal
